import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar, Footer } from '../components/Balsuite';

const PAGE_NAMES = {
  '/blog':       'Blog',
  '/changelog':  'Changelog',
  '/roadmap':    'Roadmap',
  '/help':       'Help Centre',
  '/status':     'Status Page',
  '/community':  'Community',
  '/security':   'Security',
  '/careers':    'Careers',
  '/press':      'Press',
  '/partners':   'Partners',
  '/pricing':   'Pricing',
};

export default function ComingSoonPage() {
  const { pathname } = useLocation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const pageName = PAGE_NAMES[pathname] || 'This Page';

  return (
    <div className="balsuite-page">
      <Navbar />
      <main style={{
        minHeight: 'calc(100vh - 66px - 300px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '2rem 2rem',
      }}>
        <div style={{ textAlign: 'center', maxWidth: '520px' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            background: 'rgba(99,102,241,0.08)', color: 'var(--primary)',
            padding: '0.4rem 1rem', borderRadius: '100px',
            fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.06em',
            textTransform: 'uppercase', marginBottom: '1.5rem',
          }}>
            Coming Soon
          </div>

          <h1 className="sec-h2" style={{ marginBottom: '1rem' }}>
            {pageName} is <span className="grad-text">on the way</span>
          </h1>

          <p style={{ color: 'var(--t2)', lineHeight: '1.75', marginBottom: '2rem' }}>
            We're working hard to bring you the {pageName.toLowerCase()} experience.
            Be the first to know when it launches.
          </p>

          {submitted ? (
            <div style={{
              padding: '1rem 1.5rem',
              background: 'rgba(16,185,129,0.08)',
              border: '1px solid rgba(16,185,129,0.2)',
              borderRadius: '12px', color: '#059669',
              fontSize: '0.9rem', fontWeight: 600,
            }}>
              ✓ You're on the list! We'll notify you when it's ready.
            </div>
          ) : (
            <form
              onSubmit={e => { e.preventDefault(); setSubmitted(true); }}
              style={{ display: 'flex', gap: '0.75rem', maxWidth: '400px', margin: '0 auto', flexWrap: 'wrap' }}
            >
              <input
                type="email" required value={email} onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email"
                style={{
                  flex: 1, minWidth: '200px', padding: '0.72rem 1rem',
                  borderRadius: '10px', border: '1.5px solid rgba(0,0,0,0.12)',
                  outline: 'none', fontFamily: 'Inter, sans-serif', fontSize: '0.875rem',
                  color: 'var(--t1)',
                }}
              />
              <button type="submit" className="btn-nav-grad" style={{ whiteSpace: 'nowrap' }}>
                Notify me
              </button>
            </form>
          )}

          <p style={{ marginTop: '2.5rem', fontSize: '0.875rem', color: 'var(--t3)' }}>
            <a href="/" style={{ color: 'var(--primary)', fontWeight: 500 }}>← Back to home</a>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
